import React, {
  useState,
} from 'react';

import config from 'web-config';
import {
  Flex,
  Text,
  Container,
} from 'web-styled';
import {
  Modal,
  Button,
  PaymentsDetails,
} from 'web-components';
import * as S from '../styled';

const PaymentRequired = () => {
  const [modalIsOpen, setModalState] = useState(true);

  return (
    <S.PageWrap>
      <Container
        column
        grow={1}
        padding="30px"
      >
        <S.FormTitle style={{ height: 40, padding: 6 }}>
          Payment Required
        </S.FormTitle>
        <Flex
          style={{
            width: '100%',
            minHeight: '600px',
            backgroundColor: '#fff',
            position: 'relative',
          }}
        >
          <PaymentsDetails
            required
          />
        </Flex>
      </Container>
      <S.TextCenter>
        <a href={`${config.urls.landing}/contact`}>Contact us</a>
      </S.TextCenter>
      <Modal
        title="Payment Required"
        isOpen={modalIsOpen}
        contentStyle={{
          width: 560,
          marginTop: 'auto',
        }}
        onRequestClose={() => setModalState(false)}
      >
        <Flex
          column
          width="100%"
          align="center"
          spacing={15}
        >
          <Text align="center">
            Your trial or credit card has expired.
            Please select a subscription plan and enter payment information.
          </Text>
          <Flex spacing={10}>
            <Button
              ghost
              appearance="primary"
              spacing="large"
              onClick={() => setModalState(false)}
            >
              OK
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </S.PageWrap>
  );
};

export default PaymentRequired;
